import { useMemo } from "react";
import { motion } from "framer-motion";

const INITIAL = { opacity: 0, y: 18 };
const WHILE_IN_VIEW = { opacity: 1, y: 0 };
const VIEWPORT = { once: true, margin: "-60px" };
const EASE = [0.21, 0.47, 0.32, 0.98];

export const Reveal = ({ children, delay = 0, className = "" }) => {
  const transition = useMemo(() => ({ duration: 0.6, delay, ease: EASE }), [delay, EASE]);
  return (
    <motion.div
      initial={INITIAL}
      whileInView={WHILE_IN_VIEW}
      viewport={VIEWPORT}
      transition={transition}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
